export default __webpack_public_path__ + "static/media/seeds_1.1d23be5e.png";